import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { tableSettingsProps, useTableSettings } from 'src/core/tables/useTableSettings';
import tableHelper from 'src/core/tables/tableHelper';
import { usePurchasingShippingTerms } from 'src/pages/settings/settingsRequests';

export const usePurchasingShippingTermsTable = (): [columns: GridColDef[], tableSettings: tableSettingsProps] => {
  const { rows, status, loading } = usePurchasingShippingTerms();
  const columns: GridColDef[] = useMemo(() => [
    { field: 'Id', headerName: 'Id', valueGetter: tableHelper.getFieldKeyOrValue },
    { field: 'Name', headerName: 'Name', flex: 1 },
  ], []);
  const tableSettings = useTableSettings({ tableName: 'PurchasingShippingTermsTable', idPath: ['Id'], columns, rows, status });
  tableSettings.loading = loading;
  return [columns, tableSettings];
};
